"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.post.saved': 'Post zapisany',
    'socialMediaPlan.post.saveFailed': 'Nie udało się zapisać posta',
    'socialMediaPlan.post.publish': 'Opublikuj teraz',
    'socialMediaPlan.post.publishedOn': 'Opublikowano na',
    'socialMediaPlan.post.publishFailed': 'Błąd publikacji na',
    'socialMediaPlan.post.publishError': 'Publikacja nie powiodła się.',
    'socialMediaPlan.post.duplicated': 'Post zduplikowany',
    'socialMediaPlan.post.duplicateFailed': 'Nie udało się zduplikować posta',
    'socialMediaPlan.post.deleted': 'Post usunięty',
    'socialMediaPlan.post.deleteFailed': 'Nie udało się usunąć posta',
    'socialMediaPlan.post.deleteConfirm': 'Usunąć ten post? Tej operacji nie można cofnąć.',
};
